import { render, staticRenderFns } from "./StudentCreate.vue?vue&type=template&id=a3eb2eaa&"
import script from "./StudentCreate.vue?vue&type=script&lang=js&"
export * from "./StudentCreate.vue?vue&type=script&lang=js&"
import style0 from "./StudentCreate.vue?vue&type=style&index=0&id=a3eb2eaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports